import './searchCtrl';


// WEBPACK FOOTER //
// src/js/controllers/main/index.js